<template>
<footer class="pt-5 pb-5">
    <div class="container">
        <div class="row d-flex justify-content-center">

            <div class="col">
                <div class="d-flex justify-content-center align-items-center">
                    <a class="link-footer-icon rounded" href="https://www.facebook.com/GSISLVInternational" target="_blank" title="Facebook">
                        <img src="images/facebook.svg" alt="">
                    </a>
                    <a class="link-footer-icon rounded" href="https://www.linkedin.com/company/gsi---gesellschaft-f%C3%BCr-schwei%C3%9Ftechnik-international" target="_blank" title="Linkedin">
                        <img src="images/linkedin.svg" alt="">
                    </a>
                    <a class="link-footer-icon rounded" href="https://twitter.com/gsislv" target="_blank" title="Twitter">
                        <img src="images/twitter.svg" alt="">
                    </a>
                    <a class="link-footer-icon rounded" href="https://www.xing.com/companies/gsi-gesellschaftf%C3%BCrschweisstechnikinternationalmbh" target="_blank" title="Xing">
                        <img src="images/xing.svg" alt="">
                    </a>
                </div>
            </div>

        </div>
        <div class="row d-flex justify-content-center">

            <div class="col">
                <div class="d-flex justify-content-center align-items-center flex-column flex-md-row flex-wrap mt-3">
                    <router-link class="footer-link text-blue" to="/imprint">Imprint</router-link>
                    <div class="d-none d-md-block text-blue">|</div>
                    <a class="footer-link text-blue" href="/dataprivacy" target="_blank">Privacy statement</a>
                    <div class="d-none d-md-block text-blue">|</div>
                    <router-link class="footer-link text-blue text-nowrap" to="/dataprivacy">Privacy - easily explained</router-link>
                    <div class="d-none d-md-block text-blue">|</div>
                    <router-link class="footer-link text-blue" to="/participation">Conditions of participation</router-link>
                    <div class="d-none d-md-block text-blue">|</div>
                    <router-link class="footer-link text-blue" to="/terms">Terms and conditions</router-link>
                    <div class="d-none d-md-block text-blue">|</div>
                    <a class="footer-link text-blue" href="https://schweissen.blog" target="_blank">schweissen.blog</a>
                </div>
            </div>

        </div>
    </div>
</footer>
</template>

<style lang="scss" scoped>
@import 'resources/sass/_variables.scss';

.text-blue {
    color: $blue !important;
}

.link-footer-icon {
    margin: 5px;
    background-color: $blue;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.link-footer-icon:hover {
    opacity: 0.8;
}

.footer-link {
    padding: 5px;
    line-height: 1;
}
</style>

<script>
export default {
    mounted() {

    }
}
</script>
